var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.715 0.300591L17.424 8.18459C17.79 8.56059 18 9.08459 18 9.62359V17.9996C18 19.1026 17.153 19.9996 16.112 19.9996H13V10.9996C13 10.4476 12.553 9.99959 12 9.99959H6C5.447 9.99959 5 10.4476 5 10.9996V19.9996H1.889C0.848 19.9996 0 19.1026 0 17.9996V9.62359C0 9.08459 0.21 8.56059 0.575 8.18559L8.285 0.300591C8.662 -0.0844092 9.338 -0.0844092 9.715 0.300591ZM11.0002 19H7.0002V12H11.0002V19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.85d7f290a641451fea50109e095071bf.svg";
export { ForwardRef as ReactComponent };